const locale = {
    placeholder: 'Velja tíma',
};
export default locale;



// WEBPACK FOOTER //
// ./components/time-picker/locale/is_IS.tsx